module.exports = __webpack_public_path__ + "static/media/b1.a511f07.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sijie/b1.mp3
// module id = 1SFG
// module chunks = 0